import useEventCallback from '@unifyapps/hooks/useEventCallback';
import { useAdaptFileUrl } from '@unifyapps/network/hooks/useAdaptFileUrl';
import { Stack } from '@unifyapps/ui/components/Stack';
import { useMemo } from 'react';
import { useRouter } from '../../../../../navigation';
import Image from '../../../../Image';
import type { NavigationItem } from '../../../types';
import { resolveOpenInNewTab } from '../../../utils/redirection';

type Props = {
  app: {
    name: string;
    logo: {
      small: string;
      large: string;
    };
  };
  logoNavigation: NavigationItem | undefined;
};

export function DrawerHeader({ app, logoNavigation }: Props) {
  const router = useRouter();
  const adaptFileUrl = useAdaptFileUrl();

  const imgSrc = useMemo(
    () => adaptFileUrl(app.logo.large || app.logo.small),
    [app.logo.large, app.logo.small, adaptFileUrl],
  );

  const onClick = useEventCallback(() => {
    if (logoNavigation?.type === 'URL' && logoNavigation.url) {
      if (resolveOpenInNewTab(logoNavigation)) {
        window.open(logoNavigation.url, '_blank', 'noreferrer noopener');
      } else {
        router.push(logoNavigation.url);
      }
    }
  });

  return (
    <Stack
      alignItems="flex-start"
      className="p-xl gap-md w-full ps-6"
      direction="row"
      justifyContent="space-between"
    >
      <Image alt={app.name} height={36} onClick={onClick} src={imgSrc} width={140} />
    </Stack>
  );
}
